import React from 'react';
import { Link } from 'react-router-dom';



const Project = ({ item, setDetails }) => {
  // const navigate = useNavigate();
  // const moreInDetails = id => {
  //   navigate(`/portfolio/${id}`)
  // }

  return (
    <div>
      <div key={item.id} className='flex flex-col items-center text-center'>
        <div className='mb-8'>
          <img className='rounded-2xl' src={item.image} alt='' />
        </div>
        <p className='capitalize text-accent text-sm mb-3'>{item.category}</p>
        <h3 className='text-2xl font-semibold capitalize mb-3'>{item.name}</h3>
        <p className='text-base max-w-md'>
          {item.description}
        </p>
        {/* <button onClick={() => moreInDetails(item.id)} className='mt-5 btn btn-lg bg-accent hover:bg-secondary-hover'>
          More in detail
        </button> */}

        <label onClick={() => setDetails(item)} for="details-modal" className="mt-5 btn btn-lg bg-accent hover:bg-primary-hover">  More in detail</label>



      </div>

    </div>
  );
};

export default Project;
